import { FC } from 'react'
import classes from './Button.module.css'

export enum ButtonType {
  Danger,
  Primary
}

export type ButtonProps = {
  label: string
  onClick?: () => void
  disabled?: boolean
  hidden?: boolean
  className?: string
  type?: ButtonType
}

export const Button: FC<ButtonProps> = ({ disabled, label, onClick, className, type, hidden }) => {
  const cls = [classes.root]
  className && cls.push(className)
  switch (type) {
    case ButtonType.Primary: {
      cls.push(classes.primary)
      break
    }
    case ButtonType.Danger: {
      cls.push(classes.danger)
      break
    }
  }
  return <button className={cls.join(' ')} onClick={onClick} hidden={hidden} disabled={disabled}>{label}</button>
}
